import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Activity, Users, AlertTriangle, ArrowUpRight } from 'lucide-react';
interface HallmarkSlide6Props {
  isDark?: boolean;
}
export function HallmarkSlide6({
  isDark = false
}: HallmarkSlide6Props) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  const metrics = [{
    title: 'Burnout Pulse Trends',
    icon: Activity,
    color: 'orange'
  }, {
    title: 'Manager Effectiveness',
    icon: Users,
    color: 'mint'
  }, {
    title: 'Change Fatigue Perception',
    icon: AlertTriangle,
    color: 'slate'
  }, {
    title: 'Internal Mobility Readiness',
    icon: ArrowUpRight,
    color: 'navy'
  }];
  return <motion.div className="h-full w-full overflow-y-auto overflow-x-hidden" variants={containerVariants} initial="hidden" animate="visible" data-id="element-104">
      <div className="min-h-full flex flex-col justify-center max-w-6xl mx-auto px-6 sm:px-12 py-20 sm:py-24" data-id="element-105">
        {/* Header */}
        <motion.div variants={itemVariants} className="text-center mb-12 sm:mb-16" data-id="element-106">
          <h1 className={`text-3xl sm:text-5xl font-serif font-medium mb-4 sm:mb-6 tracking-tight ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-107">
            Business-Level Signal
          </h1>
          <p className={`text-base sm:text-xl max-w-3xl mx-auto leading-relaxed ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-108">
            Lightweight, practical integration with Hallmark's current tracking
          </p>
        </motion.div>

        {/* Metrics Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8" data-id="element-109">
          {metrics.map((metric, idx) => <motion.div key={idx} variants={itemVariants} className={`rounded-3xl p-8 text-center shadow-sm hover:shadow-md transition-all duration-300 ${isDark ? 'bg-white/[0.03] border border-white/10' : 'bg-white border border-heliona-beige'}`} data-id="element-110">
              <div className={`w-16 h-16 rounded-2xl flex items-center justify-center mb-6 mx-auto border ${isDark ? `bg-heliona-${metric.color}/10 border-heliona-${metric.color}/30` : `bg-heliona-${metric.color}/10 border-heliona-${metric.color}/20`}`} data-id="element-111">
                <metric.icon className={`w-8 h-8 ${isDark ? `text-heliona-${metric.color}` : `text-heliona-${metric.color === 'mint' ? 'mint-dark' : metric.color}`}`} data-id="element-112" />
              </div>
              <h3 className={`text-lg font-bold leading-tight ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-113">
                {metric.title}
              </h3>
            </motion.div>)}
        </div>
      </div>
    </motion.div>;
}